import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MuiSettingsRow} from '@app/custom-mui-components';
import {Box, Switch, Tooltip, Typography, useTheme} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Feature} from '@app/model';
import {FeatureUtil} from '@app/util';
import {FeatureToggleProps} from '../technician/TechnicianFeatureSettings';
import {settingsRowLabelSx} from '../AppSettings';

export function BedLinenFeature(props: FeatureToggleProps) {
	const {userObject, handleFeatureChange} = props;
	const {t} = useTranslation(['tenantAdmin']);
	const theme = useTheme();

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const isBedLinenFeatureOn = FeatureUtil.hasEnabledFeature(userObject, Feature.BEDLINEN);

	const helpText = (
		<Box sx={{padding: 1}}>
			<Typography>{t('tenantAdmin:app.bedlinen.bedsheetInfo')}</Typography>
		</Box>
	);

	return (
		<MuiSettingsRow>
			<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
				<Typography sx={settingsRowLabelSx(theme)}>
					<strong>{t('tenantAdmin:app.bedlinen.bedsheetLabel')}:</strong>
				</Typography>
				<Tooltip title={helpText} arrow>
					<HelpOutlineIcon color="primary" fontSize="small" sx={{ml: 1}} />
				</Tooltip>
			</Box>
			<Switch
				disabled={isLoading}
				checked={isBedLinenFeatureOn}
				onChange={() =>
					handleFeatureChange(isBedLinenFeatureOn, Feature.BEDLINEN, setIsLoading)
				}
			/>
		</MuiSettingsRow>
	);
}
